import { useEffect, useState } from 'react';
import { useScrollProgress, mapRange } from '../heroSignals';

const items = [
  { label: 'MODEL', value: 'AX-07' },
  { label: 'WEIGHT', value: '184g' },
  { label: 'CELL', value: '5000mAh' },
  { label: 'FRAME', value: 'Titanium' },
  { label: 'DRIVER', value: '40mm Beryllium' },
];

export default function BottomInfoBar() {
  const [mounted, setMounted] = useState(false);
  const scroll = useScrollProgress();

  useEffect(() => {
    const raf = requestAnimationFrame(() => setMounted(true));
    return () => cancelAnimationFrame(raf);
  }, []);

  // Fade out as Chapter 002 arrives — same window as the labels layer.
  const ch2FadeOut = 1 - mapRange(scroll, 0.56, 0.64);

  return (
    <div
      className="absolute bottom-0 left-0 right-0 z-20"
      style={{
        fontFamily:
          'Inter, "Helvetica Neue", Helvetica, Arial, system-ui, sans-serif',
        opacity: ch2FadeOut,
        transform: `translateY(${(1 - ch2FadeOut) * 20}px)`,
        transition: 'opacity 160ms linear, transform 160ms linear',
        pointerEvents: ch2FadeOut < 0.05 ? 'none' : undefined,
      }}
    >
      {/* thin divider */}
      <div
        className="mx-8"
        style={{
          height: '1px',
          background:
            'linear-gradient(to right, rgba(255,255,255,0) 0%, rgba(255,255,255,0.22) 15%, rgba(255,255,255,0.22) 85%, rgba(255,255,255,0) 100%)',
          transform: mounted ? 'scaleX(1)' : 'scaleX(0)',
          transformOrigin: 'center',
          transition: 'transform 1100ms cubic-bezier(0.22,1,0.36,1) 500ms',
        }}
      />

      <div className="grid grid-cols-5 px-8 py-6">
        {items.map((it, idx) => (
          <div
            key={it.label}
            className={`flex flex-col gap-1.5 ${
              idx === 0 ? 'items-start' : 'items-center'
            } ${idx === items.length - 1 ? 'items-end' : ''}`}
            style={{
              opacity: mounted ? 1 : 0,
              transform: mounted ? 'translateY(0)' : 'translateY(14px)',
              transition: `opacity 900ms ease ${700 + idx * 90}ms, transform 900ms cubic-bezier(0.22,1,0.36,1) ${
                700 + idx * 90
              }ms`,
            }}
          >
            <span
              className="uppercase"
              style={{
                color: 'rgba(255,255,255,0.42)',
                fontSize: '11px',
                letterSpacing: '0.28em',
                fontWeight: 500,
              }}
            >
              {it.label}
            </span>
            <span
              className="text-white"
              style={{
                fontSize: '16px',
                fontWeight: 700,
                letterSpacing: '0.02em',
              }}
            >
              {it.value}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}